import { alertService, createStorePersist, RequestStatus } from "common-frontend-components";
import { getStorageCall } from "@yehonadav/safestorage";
import { useEffect } from "react";
import { callGetCategoriesAsync } from "../apis/categories";
const persistOptions = {
    name: `ramibarilan/categories/store`,
    whitelist: ["categoryList"],
    getStorage: getStorageCall,
};
const { useStore, fetchStore, set, get } = createStorePersist({
    persistOptions,
    persistAfterClearingStorage: false,
    getDefaultValues: () => ({
        categories: {},
        categoryList: [],
        categoryFilters: [],
        requestStatus: RequestStatus.pending,
    })
});
const setCategories = (categoryList) => {
    const categories = {};
    categoryList.forEach(category => { categories[category.id] = category; });
    set({ categories, categoryList });
};
// set categories from storage
setCategories(get().categoryList);
const getCategoryFilters = () => get().categoryFilters;
const setCategoryFilters = (categoryFilters) => set({ categoryFilters });
const useCategoryFilters = () => useStore(fetchStore.categoryFilters);
export const categoriesStore = {
    getCategoryMap: () => get().categories,
    getCategories: () => get().categoryList,
    getCategoryFilters,
    setCategories,
    setCategoryFilters,
    useCategory: (id) => useStore(s => s.categories[id]),
    useCategories: () => useStore(fetchStore.categoryList),
    useCategoryFilters,
    getRequestStatus: () => get().requestStatus,
    // tslint:disable-next-line:no-shadowed-variable
    setRequestStatus: (requestStatus) => { console.log({ requestStatus }); const s = get(); s.requestStatus = requestStatus; set({ requestStatus }); },
    useRequestStatus: () => useStore(fetchStore.requestStatus),
    useLoad: () => {
        const status = categoriesStore.useRequestStatus();
        const data = categoriesStore.useCategories();
        useEffect(() => {
            if (get().requestStatus !== RequestStatus.pending)
                return;
            categoriesStore.setRequestStatus(RequestStatus.loading);
            callGetCategoriesAsync()
                .then((items) => {
                categoriesStore.setCategories(items);
                categoriesStore.setRequestStatus(RequestStatus.loaded);
            })
                .catch((e) => {
                alertService.error(e);
                categoriesStore.setRequestStatus(RequestStatus.failed);
            });
        }, [status]);
        return { status, data };
    },
};
//# sourceMappingURL=useCategoriesStore.js.map